/**
* カートページをリロード
*/
function reloadCart(){
  location.href = '/cart';
}

/**
* 数値をカンマ区切りに変換
* @param {int} x 数値
* @return {string} カンマ区切りの文字列
*/
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
